import Address from 'root/apps/QuoteMachineIntegration/state/Address';

export default class InvoicingCustomer {
  lsCustomerId: string;
  lsCustomerCreditAccountId: string;
  firstName: string;
  lastName: string;
  email: string;
  address: Address;

  constructor(customer: Customer | null) {
    this.lsCustomerId = `${customer?.customerID}` || '';
    this.lsCustomerCreditAccountId = customer?.creditAccountID
      ? `${customer?.creditAccountID}`
      : '';
    this.firstName = customer?.firstName || '';
    this.lastName = customer?.lastName || '';
    this.address = customer?.Contact?.Addresses?.ContactAddress
      ? new Address(customer?.Contact?.Addresses?.ContactAddress)
      : new Address({
          address1: '',
          address2: '',
          city: '',
          state: '',
          stateCode: '',
          zip: '',
          country: '',
          countryCode: '',
        });
    let customerEmail = '';

    if (typeof customer?.Contact?.Emails === 'object' && customer?.Contact?.Emails?.ContactEmail) {
      const contactEmail = customer.Contact.Emails.ContactEmail;
      if (Array.isArray(contactEmail)) {
        customerEmail = contactEmail[0]?.address || '';
      } else {
        customerEmail = contactEmail.address || '';
      }
    }
    this.email = customerEmail.toString();
  }
}
